import { BaseAsset } from 'queries/assets/contract';

export function getTooltipText(trailWithoutThisAsset: BaseAsset[], assetName?: string) {
  if (trailWithoutThisAsset.length === 0) {
    return assetName;
  }
  const tooltipText = trailWithoutThisAsset.map((i) => i.name).join(' / ');
  return `${tooltipText} / ${assetName}`;
}

export function getBreadcrumbText(trailWithoutThisAsset: BaseAsset[], assetName: string) {
  trailWithoutThisAsset.reverse();
  if (trailWithoutThisAsset.length > 2) {
    return `${trailWithoutThisAsset[0].name} / ... / ${assetName}`;
  }
  return getTooltipText(trailWithoutThisAsset, assetName);
}
